/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

interface ExperienceDetail {
  value: string;
  optionText: string;
}

enum CompanionCareExperienceTypes {
  CONVERSATION_COMPANIONSHIP = 'CONVERSATION_COMPANIONSHIP',
  SAFETY_SUPERVISION = 'SAFETY_SUPERVISION',
  MEAL_PREPARATION = 'MEAL_PREPARATION',
  MEDICATION_REMINDERS = 'MEDICATION_REMINDERS',
  SOCIAL_ACTIVITIES = 'SOCIAL_ACTIVITIES',
  LIGHT_HOUSEKEEPING = 'LIGHT_HOUSEKEEPING',
  EXERCISE_PHYSICAL_ACTIVITIES = 'EXERCISE_PHYSICAL_ACTIVITIES',
  LAUNDRY_LINEN_CHANGES = 'LAUNDRY_LINEN_CHANGES',
  SHOPPING = 'SHOPPING',
  MOBILITY_ASSISTANCE = 'MOBILITY_ASSISTANCE',
  BATHING = 'BATHING',
  DRESSING = 'DRESSING',
  GROOMING = 'GROOMING',
  FEEDING_SPECIAL_DIET = 'FEEDING_SPECIAL_DIET',
  TOILETING = 'TOILETING',
}

enum HousekeepingExperienceTypes {
  GENERAL_CLEANING = 'GENERAL_CLEANING',
  SPECIALIZED_CLEANING = 'SPECIALIZED_CLEANING',
  MEAL_PREPARATION = 'MEAL_PREPARATION',
  DISHES = 'DISHES',
  LAUNDRY = 'LAUNDRY',
  ERRANDS = 'ERRANDS',
  GENERAL_MAINTENANCE = 'GENERAL_MAINTENANCE',
  ORGANIZATION = 'ORGANIZATION',
}

enum PetCareExperienceTypes {
  DOGS = 'DOGS',
  CATS = 'CATS',
  BIRDS = 'BIRDS',
  FISH = 'FISH',
  HORSES = 'HORSES',
  FARM_ANIMALS = 'FARM_ANIMALS',
  REPTILES_AMPHIBIANS = 'REPTILES_AMPHIBIANS',
  EXOTIC_PETS = 'EXOTIC_PETS',
  SMALL_MAMMALS = 'SMALL_MAMMALS',
  OTHER = 'OTHER',
}

type CompanionCareExperienceOptions = {
  [key in CompanionCareExperienceTypes]: ExperienceDetail;
};

type HousekeepingExperienceOptions = {
  [key in HousekeepingExperienceTypes]: ExperienceDetail;
};

type PetCareExperienceOptions = {
  [key in PetCareExperienceTypes]: ExperienceDetail;
};

const companionCareExperienceOptions: CompanionCareExperienceOptions = {
  [CompanionCareExperienceTypes.CONVERSATION_COMPANIONSHIP]: {
    value: CompanionCareExperienceTypes.CONVERSATION_COMPANIONSHIP,
    optionText: 'Conversation and companionship',
  },
  [CompanionCareExperienceTypes.SAFETY_SUPERVISION]: {
    value: CompanionCareExperienceTypes.SAFETY_SUPERVISION,
    optionText: 'Safety supervision',
  },
  [CompanionCareExperienceTypes.MEAL_PREPARATION]: {
    value: CompanionCareExperienceTypes.MEAL_PREPARATION,
    optionText: 'Meal preparation',
  },
  [CompanionCareExperienceTypes.MEDICATION_REMINDERS]: {
    value: CompanionCareExperienceTypes.MEDICATION_REMINDERS,
    optionText: 'Medication reminders',
  },
  [CompanionCareExperienceTypes.SOCIAL_ACTIVITIES]: {
    value: CompanionCareExperienceTypes.SOCIAL_ACTIVITIES,
    optionText: 'Social Activities',
  },
  [CompanionCareExperienceTypes.LIGHT_HOUSEKEEPING]: {
    value: CompanionCareExperienceTypes.LIGHT_HOUSEKEEPING,
    optionText: 'Light housekeeping',
  },
  [CompanionCareExperienceTypes.EXERCISE_PHYSICAL_ACTIVITIES]: {
    value: CompanionCareExperienceTypes.EXERCISE_PHYSICAL_ACTIVITIES,
    optionText: 'Exercise or physical activities',
  },
  [CompanionCareExperienceTypes.LAUNDRY_LINEN_CHANGES]: {
    value: CompanionCareExperienceTypes.LAUNDRY_LINEN_CHANGES,
    optionText: 'Laundry and linen changes',
  },
  [CompanionCareExperienceTypes.SHOPPING]: {
    value: CompanionCareExperienceTypes.SHOPPING,
    optionText: 'Shopping',
  },
  [CompanionCareExperienceTypes.MOBILITY_ASSISTANCE]: {
    value: CompanionCareExperienceTypes.MOBILITY_ASSISTANCE,
    optionText: 'Mobility assistance',
  },
  [CompanionCareExperienceTypes.BATHING]: {
    value: CompanionCareExperienceTypes.BATHING,
    optionText: 'Bathing',
  },
  [CompanionCareExperienceTypes.DRESSING]: {
    value: CompanionCareExperienceTypes.DRESSING,
    optionText: 'Dressing',
  },
  [CompanionCareExperienceTypes.GROOMING]: {
    value: CompanionCareExperienceTypes.GROOMING,
    optionText: 'Grooming',
  },
  [CompanionCareExperienceTypes.FEEDING_SPECIAL_DIET]: {
    value: CompanionCareExperienceTypes.FEEDING_SPECIAL_DIET,
    optionText: 'Feeding and special diet',
  },
  [CompanionCareExperienceTypes.TOILETING]: {
    value: CompanionCareExperienceTypes.TOILETING,
    optionText: 'Toileting',
  },
};

const housekeepingExperienceOptions: HousekeepingExperienceOptions = {
  [HousekeepingExperienceTypes.GENERAL_CLEANING]: {
    value: HousekeepingExperienceTypes.GENERAL_CLEANING,
    optionText: 'General cleaning',
  },
  [HousekeepingExperienceTypes.SPECIALIZED_CLEANING]: {
    value: HousekeepingExperienceTypes.SPECIALIZED_CLEANING,
    optionText: 'Specialized cleaning',
  },
  [HousekeepingExperienceTypes.MEAL_PREPARATION]: {
    value: HousekeepingExperienceTypes.MEAL_PREPARATION,
    optionText: 'Preparing snacks/meals',
  },
  [HousekeepingExperienceTypes.DISHES]: {
    value: HousekeepingExperienceTypes.DISHES,
    optionText: 'Washing dishes',
  },
  [HousekeepingExperienceTypes.LAUNDRY]: {
    value: HousekeepingExperienceTypes.LAUNDRY,
    optionText: 'Doing laundry',
  },
  [HousekeepingExperienceTypes.ERRANDS]: {
    value: HousekeepingExperienceTypes.ERRANDS,
    optionText: 'Running errands',
  },
  [HousekeepingExperienceTypes.GENERAL_MAINTENANCE]: {
    value: HousekeepingExperienceTypes.GENERAL_MAINTENANCE,
    optionText: 'General maintenance',
  },
  [HousekeepingExperienceTypes.ORGANIZATION]: {
    value: HousekeepingExperienceTypes.ORGANIZATION,
    optionText: 'Organization',
  },
};

const petCareExperienceOptions: PetCareExperienceOptions = {
  [PetCareExperienceTypes.DOGS]: {
    value: PetCareExperienceTypes.DOGS,
    optionText: 'Dogs',
  },
  [PetCareExperienceTypes.CATS]: {
    value: PetCareExperienceTypes.CATS,
    optionText: 'Cats',
  },
  [PetCareExperienceTypes.BIRDS]: {
    value: PetCareExperienceTypes.BIRDS,
    optionText: 'Birds',
  },
  [PetCareExperienceTypes.FISH]: {
    value: PetCareExperienceTypes.FISH,
    optionText: 'Fish',
  },
  [PetCareExperienceTypes.HORSES]: {
    value: PetCareExperienceTypes.HORSES,
    optionText: 'Horses',
  },
  [PetCareExperienceTypes.FARM_ANIMALS]: {
    value: PetCareExperienceTypes.FARM_ANIMALS,
    optionText: 'Farm animals',
  },
  [PetCareExperienceTypes.REPTILES_AMPHIBIANS]: {
    value: PetCareExperienceTypes.REPTILES_AMPHIBIANS,
    optionText: 'Reptiles or amphibians',
  },
  [PetCareExperienceTypes.EXOTIC_PETS]: {
    value: PetCareExperienceTypes.EXOTIC_PETS,
    optionText: 'Exotic pets',
  },
  [PetCareExperienceTypes.SMALL_MAMMALS]: {
    value: PetCareExperienceTypes.SMALL_MAMMALS,
    optionText: 'Small mammals',
  },
  [PetCareExperienceTypes.OTHER]: {
    value: PetCareExperienceTypes.OTHER,
    optionText: 'Other',
  },
};

export { companionCareExperienceOptions, housekeepingExperienceOptions, petCareExperienceOptions };
